function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17 7h2a1 1 0 011 1v12a1 1 0 01-1 1H3a1 1 0 01-1-1V8a1 1 0 011-1h2V6a6 6 0 1112 0v1zM4 9v10h14V9H4zm6 4h2v2h-2v-2zm-4 0h2v2H6v-2zm8 0h2v2h-2v-2zm1-6V6a4 4 0 10-8 0v1h8z",
  fill: "#1E388B"
});
function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none"
  }, props), _ref);
}
export default SvgLock;